/* src/app/views/area-publica/home-page/card-timing-info-public/card-timing-info-public.component.scss */
.timing-item {
  background-color: #FFFFFF;
  width: 100%;
  border-radius: 45px;
  padding: 9px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 8px;
  margin-bottom: 8px;
}
.timing-item .icon-name {
  display: flex;
  align-items: center;
}
.timing-item .icon-name .icon {
  border-radius: 100%;
  width: 77px;
  height: 77px;
  display: flex;
  align-items: center;
}
.timing-item .icon-name .icon img {
  margin: auto;
}
.timing-item .icon-name .title {
  font: normal normal normal 24px/30px "Alegreya Sans Medium", sans-serif;
  letter-spacing: 0px;
  color: #757575;
  margin-left: 24px;
  font-weight: bold;
}
.timing-item-solo {
  width: 100%;
  height: 200px;
  background: #FFFFFF 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.1607843137);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  text-align: center;
  margin-left: 8px;
  margin-right: 8px;
  padding: 10px 10px 25px 10px;
}
.timing-item-solo .icon {
  border-radius: 100%;
  width: 77px;
  height: 77px;
  display: flex;
  align-items: center;
  margin: auto;
  margin-top: -38px;
  margin-bottom: 0;
}
.timing-item-solo .icon img {
  margin: auto;
  width: auto;
}
.timing-item-solo .title {
  font: normal normal normal 24px/30px "Alegreya Sans Medium", sans-serif;
  letter-spacing: 0px;
  color: #757575;
  margin: auto;
  text-align: center;
  max-width: 105px;
  overflow-wrap: normal;
}
.item-carousel {
  padding: 20px 10px 20px 10px;
  margin: 10px;
}
* > :host ::ng-deep .mat-button-wrapper div span {
  color: #007ac2 !important;
}
.light {
  background-color: #4C90B7;
}
.dark {
  background-color: #284395;
}
/*# sourceMappingURL=card-timing-info-public.component.css.map */
